<template>
  <div id="app" class="app-container">
    <!-- 顶部区域 -->
    <div class="header">
      <div class="logo-container">
        <i class="fas fa-mobile-alt logo-icon"></i>
      </div>
      <h1 class="app-name">TI Studio APP 下载</h1>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 下载入口卡片 -->
      <div class="download-cards">
        <!-- 小米手机下载入口 -->
        <div class="download-card">
          <div class="card-header">
            <div class="phone-icon mi-icon">
              <i class="el-icon-mobile-phone"></i>
            </div>
            <div>
              <h2 class="card-title">小米手机下载</h2>
              <div class="device-badge">MIUI专属优化</div>
            </div>
          </div>
          <p class="card-description">
            专为小米手机深度优化，完美适配MIUI系统，发挥硬件最佳性能，体验更流畅。
          </p>
          <button
            class="download-btn mi-btn"
            @click="handleDownload('mi')"
          >
            <i class="el-icon-download btn-icon"></i> 下载
          </button>
        </div>

        <!-- 其他手机下载入口 -->
        <div class="download-card">
          <div class="card-header">
            <div class="phone-icon other-icon">
              <i class="el-icon-mobile-phone"></i>
            </div>
            <div>
              <h2 class="card-title">其他手机下载</h2>
              <div class="device-badge">全机型兼容</div>
            </div>
          </div>
          <p class="card-description">
            适用于华为、OPPO、vivo、三星等其他多种安卓手机，兼容性强，功能全面。
          </p>
          <button
            class="download-btn other-btn"
            @click="handleDownload('other')"
          >
            <i class="el-icon-download btn-icon"></i> 下载
          </button>
        </div>
      </div>
    </div>
    <!-- 微信提示模态框 -->
    <div v-if="showWeChatModal" class="modal-overlay" @click="showWeChatModal = false">
      <div class="modal-content" @click.stop>
        <i class="fas fa-exclamation-circle modal-icon"></i>
        <h2 class="modal-title">请在浏览器中打开</h2>
        <p class="modal-text">
          检测到您正在微信内浏览，由于微信的限制，无法直接下载应用。
          <br><br>
          请点击右上角 <strong>···</strong> 按钮，选择 <strong>"在浏览器中打开"</strong>，然后返回此页面进行下载。
        </p>
        <button class="modal-btn" @click="showWeChatModal = false">我知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
import encryption from '../../utils/encryption.js'
import QRCode from 'qrcode'

export default {
  name: 'AppDownload',
  data() {
    return {
      showWeChatModal: false,
      isWeChat: false,
      deviceType: '检测中...',
      browserType: 'unknown',
      browserTypeText: '检测中...',
      productId: ''
    }
  },
  mounted() {
    this.detectBrowser()
    this.detectDevice()
    this.productId = decodeURIComponent(this.$route.query.productId)
  },
  methods: {
    // 检测浏览器环境
    detectBrowser() {
      const ua = navigator.userAgent.toLowerCase()

      // 检测微信
      if (ua.indexOf('micromessenger') !== -1) {
        this.isWeChat = true
        this.browserType = 'wechat'
        this.browserTypeText = '微信浏览器'
      } else if (ua.indexOf('qqbrowser') !== -1) { // 检测其他浏览器
        this.browserType = 'qq'
        this.browserTypeText = 'QQ浏览器'
      } else if (ua.indexOf('mqqbrowser') !== -1) {
        this.browserType = 'qq'
        this.browserTypeText = 'QQ浏览器'
      } else if (ua.indexOf('ucbrowser') !== -1) {
        this.browserType = 'uc'
        this.browserTypeText = 'UC浏览器'
      } else if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1) {
        this.browserType = 'safari'
        this.browserTypeText = 'Safari浏览器'
      } else if (ua.indexOf('chrome') !== -1) {
        this.browserType = 'chrome'
        this.browserTypeText = 'Chrome浏览器'
      } else if (ua.indexOf('firefox') !== -1) {
        this.browserType = 'firefox'
        this.browserTypeText = 'Firefox浏览器'
      } else {
        this.browserType = 'other'
        this.browserTypeText = '其他浏览器'
      }
    },

    // 检测设备类型
    detectDevice() {
      const ua = navigator.userAgent

      // 检测小米设备
      if (/xiaomi|mi\s+/i.test(ua)) {
        this.deviceType = '小米手机'
      // eslint-disable-next-line brace-style
      }
      // 检测其他品牌
      else if (/huawei|honor/i.test(ua)) {
        this.deviceType = '华为/荣耀手机'
      } else if (/oppo/i.test(ua)) {
        this.deviceType = 'OPPO手机'
      } else if (/vivo/i.test(ua)) {
        this.deviceType = 'vivo手机'
      } else if (/samsung/i.test(ua)) {
        this.deviceType = '三星手机'
      // eslint-disable-next-line brace-style
      }
      // 检测iOS设备
      else if (/iphone|ipad|ipod/i.test(ua)) {
        this.deviceType = 'iPhone/iPad'
      // eslint-disable-next-line brace-style
      }
      // 检测安卓设备
      else if (/android/i.test(ua)) {
        this.deviceType = '安卓手机'
      } else {
        this.deviceType = '其他设备'
      }
    },

    // 处理下载点击事件
    handleDownload(type) {
      // 如果在微信内，显示提示模态框
      if (this.isWeChat) {
        this.showWeChatModal = true
        return
      }

      // 模拟下载跳转
      if (type === 'mi') {
        const productId = encryption.Encrypt('1986256084978065410')
        this.$router.push({
          path: '/productload',
          query: { productId: encodeURIComponent(productId) }
        })
      } else {
        this.$router.push({
          path: '/productload',
          query: { productId: encodeURIComponent(this.productId), isPushed: true }
        })
      }
    },

    // 显示下载消息
    showDownloadMessage(storeName, url) {
      alert(`即将跳转到${storeName}下载页面...\n\n（演示环境，实际将跳转到：${url}）`)
      // 实际使用时取消注释下面这行
      // window.location.href = url
    },
    dwCode(info) {
      this.currentVersion = info
      this.codeVisible = true
      this.$nextTick(() => {
        this.getQRCode()
      })
    },
    getQRCode() {
      const opts = {
        errorCorrectionLevel: 'H', // 容错级别
        type: 'image/png', // 生成的二维码类型
        quality: 0.3, // 二维码质量
        margin: 12, // 二维码留白边距
        width: 200, // 宽
        height: 180, // 高
        color: {
          dark: '#333333', // 前景色
          light: '#fff' // 背景色
        }
      }

      this.productId = encryption.Encrypt(this.proInfo.id)
      this.versionId = encryption.Encrypt(this.currentVersion.id)
      this.qrcodeurl =
        location.origin +
        '/#/productload?productId=' +
        encodeURIComponent(this.productId) +
        '&versionId=' +
        encodeURIComponent(this.versionId) // 生成的二维码为URL地址js
      const msg = document.getElementById('QRCode_box')
      QRCode.toCanvas(msg, this.qrcodeurl, opts)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

body {
  background: linear-gradient(135deg, #6a93cb 0%, #4a6fa5 100%);
  min-height: 100vh;
  color: #333;
  padding: 0;
  overflow-x: hidden;
}

.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 顶部区域 */
.header {
  background: linear-gradient(135deg, #4a6fa5 0%, #3a5a8c 100%);
  color: white;
  text-align: center;
  padding: 30px 20px 40px;
  border-radius: 0 0 30px 30px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1;
}

.logo-container {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.fa-mobile-alt {
  background-size: 100% 100%;
  background-image: url('~@/assets/img/icon_product-select.png');
  width: 80px;
  height: 80px;
  border-radius: 20px;
}

.logo-icon {
  color: #4a6fa5;
  font-size: 36px;
}

.app-name {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  letter-spacing: 1px;
}

.app-tagline {
  font-size: 16px;
  opacity: 0.9;
  line-height: 1.5;
  max-width: 300px;
  margin: 0 auto;
}

/* 主要内容区域 */
.main-content {
  flex: 1;
  padding: 20px 20px 0px 20px;
  margin-top: -20px;
  position: relative;
  z-index: 2;
}

.download-cards {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 25px;
}

.download-card {
  background: white;
  border-radius: 20px;
  padding: 25px 20px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.download-card:active {
  transform: scale(0.98);
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.phone-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 24px;
}

.mi-icon {
  background: linear-gradient(135deg, #ff8c42 0%, #ff6b00 100%);
  color: white;
}

.other-icon {
  background: linear-gradient(135deg, #6a93cb 0%, #4a6fa5 100%);
  color: white;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.card-description {
  font-size: 15px;
  line-height: 1.5;
  color: #666;
  margin-bottom: 25px;
}

.download-btn {
  display: block;
  width: 100%;
  padding: 18px;
  border-radius: 15px;
  text-decoration: none;
  font-weight: 600;
  font-size: 17px;
  text-align: center;
  border: none;
  color: white;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  letter-spacing: 0.5px;
}

.mi-btn {
  background: linear-gradient(to right, #ff6b00, #ff8c42);
}

.other-btn {
  background: linear-gradient(to right, #4a6fa5, #6a93cb);
}

.download-btn:active {
  transform: scale(0.98);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
}

.btn-icon {
  margin-right: 8px;
}

/* 检测信息区域 */
.detection-info {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 15px;
  padding: 18px;
  margin-bottom: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  border-left: 5px solid #4a6fa5;
}

.info-title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  color: #333;
  font-weight: 600;
  font-size: 16px;
}

.info-icon {
  margin-right: 10px;
  color: #4a6fa5;
}

.info-content {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.wechat-warning {
  background: rgba(255, 243, 224, 0.9);
  border-left-color: #ff6b00;
  margin-top: 10px;
}

.wechat-warning .info-icon {
  color: #ff6b00;
}

/* 微信指引区域 */
.wechat-steps {
  background: white;
  border-radius: 15px;
  padding: 20px;
  margin-top: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.steps-title {
  font-size: 17px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.steps-title i {
  margin-right: 10px;
  color: #ff6b00;
}

.steps-list {
  padding-left: 10px;
  list-style: none
}

.step-item {
  margin-bottom: 12px;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.step-number {
  display: inline-block;
  width: 22px;
  height: 22px;
  background: #4a6fa5;
  color: white;
  border-radius: 50%;
  text-align: center;
  line-height: 22px;
  font-size: 12px;
  margin-right: 10px;
}

/* 底部区域 */
.footer {
  background: #f8f9fa;
  padding: 20px;
  text-align: center;
  border-top: 1px solid #eee;
  margin-top: 20px;
}

.footer-links {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.footer-link {
  color: #666;
  text-decoration: none;
  font-size: 13px;
  margin: 0 10px;
  padding: 5px 0;
}

.footer-link:active {
  color: #4a6fa5;
}

.copyright {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
}

/* 微信提示模态框 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background-color: white;
  border-radius: 20px;
  padding: 30px 25px;
  width: 100%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  animation: modalAppear 0.3s ease-out;
}

@keyframes modalAppear {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-icon {
  font-size: 60px;
  color: #ff6b00;
  margin-bottom: 20px;
}

.modal-title {
  font-size: 22px;
  margin-bottom: 15px;
  color: #333;
  font-weight: 600;
}

.modal-text {
  font-size: 16px;
  color: #666;
  margin-bottom: 25px;
  line-height: 1.5;
}

.modal-text strong {
  color: #4a6fa5;
}

.modal-btn {
  background: linear-gradient(to right, #4a6fa5, #6a93cb);
  color: white;
  border: none;
  padding: 16px 40px;
  border-radius: 15px;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 5px 15px rgba(74, 111, 165, 0.3);
  width: 100%;
}

.modal-btn:active {
  transform: scale(0.98);
}

/* 设备类型标签 */
.device-badge {
  display: inline-block;
  background: #e9f0ff;
  color: #4a6fa5;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  margin-left: 10px;
}

/* 响应式调整 */
@media (min-width: 768px) {
  body {
    padding: 20px;
  }

  .app-container {
    max-width: 500px;
    margin: 0 auto;
    border-radius: 30px;
    overflow: hidden;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
  }

  .header {
    border-radius: 0;
  }
}
</style>

